<div
  class="toolbar-toggle-item"
  [ngClass]="isSelected ? 'is-selected' : 'is-not-selected'"
  (click)="onItemClicked()"
>
  <mat-icon [matBadge]="count" matBadgeColor="warn">{{ finalIcon }}</mat-icon>
</div>
